import { ApiResponse } from "../../../interfaces/apiResponseInterface";
import { IApiPagination } from "../../../interfaces/IPagination";
import {
  GetRolesResponse,
  RoleInterface,
  TRoleFilter,
} from "../../../interfaces/roleInterface";
import axiosTeethTab from "../../../services/apiCall";

type RoleApiInterface = {
  getRoles: (
    filter: TRoleFilter,
    pagination: IApiPagination,
  ) => Promise<ApiResponse<GetRolesResponse>>;
  saveRole: (role: RoleInterface) => Promise<ApiResponse<RoleInterface>>;
  getRoleById: (id: string) => Promise<ApiResponse<RoleInterface>>;
  enable: (id: string) => Promise<ApiResponse<RoleInterface>>;
  disable: (id: string) => Promise<ApiResponse<RoleInterface>>;
};

export const roleApi: RoleApiInterface = {
  getRoles: async (filter, pagination) => {
    return await axiosTeethTab.get("roles/filter", {
      params: { filter, pagination },
    });
  },
  saveRole: async (role) => {
    const endpoint = role._id ? `roles/${role._id}` : "roles";
    return await axiosTeethTab.post<RoleInterface>(endpoint, role);
  },
  getRoleById: async (id: string) => {
    return await axiosTeethTab.get<RoleInterface>(`roles/${id}`);
  },
  enable: async (id: string) => {
    return await axiosTeethTab.patch<RoleInterface>(`roles/${id}/enable`);
  },
  disable: async (id: string) => {
    return await axiosTeethTab.patch<RoleInterface>(`roles/${id}/disable`);
  },
};
